<template>
  <div>
    <a-button class="btn" @click="print">打印</a-button>
    <div class="row">
      <div class="col-25" v-for="(item, index) in list" :key="index">
        <div class="goods-item">
          <img :src="item.qr" alt="" />
          <p>{{ item.name }} {{ item.sn }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
@media print {
  .btn{
    display: none;
  }
}

.goods-item {
  margin: 38px 10px;
  background: #fff;
  text-align: center;
  img {
    width: 100%;
  }
  p {
    padding: 0 20px 20px 20px;
  }
}
</style>

<script>
import QRCode from "qrcode";

export default {
  data() {
    return {
      qr_url: "",
      auc_id: null,
      list: [],
    };
  },
  async created() {
    this.auc_id = this.$route.query.auc_id;
    await this.getList();
  },
  methods: {
    print() {
      window.print();
    },
    async getList() {
      const r = await this.$axios.get("/auction/goods/getList", {
        params: {
          auc_id: this.auc_id,
        },
      });
      console.log(r);

      if (r.status != 1) return;

      for (let item of r.list) {
        item.qr = await QRCode.toDataURL(
          "http://wechat.ganvana.com/exh/auction/item/" + item.id
        );
      }

      this.list = r.list;
    },
  },
};
</script>